// Hooks
import { useMessageFilter } from '@/utils/hooks/conversations/useMessageFilter';

// Constants/Libs
import { MESSAGE_FILTER_META } from '@/components/pages/conversations/SocialInbox/const';

// Components
import { SocialInboxConversationMessages } from '@/components/pages/conversations/SocialInbox';

export const SocialInboxConversationContent = () => {
    const { messageFilter } = useMessageFilter();

    if (messageFilter === MESSAGE_FILTER_META.dm.key) {
        return null;
    }

    return <SocialInboxConversationMessages />;
};
